/*
  Accessibility changes for public and admin pages
*/


/**
 *
 */
function accessibleIcons(parent, opts) {
  if (typeof opts == 'undefined') { opts = {}; }
  if (typeof parent !== 'undefined') {
    opts.parent = parent;
  }
  springSpace.sui.icontip(opts);
}


jQuery(document).ready(function(){


  // Taken from https://github.com/paypal/bootstrap-accessibility-plugin/blob/master/plugins/js/bootstrap-accessibility.js
  // DB added aria-hidden changes
  // DROPDOWN Extension
  // ===============================

  var toggle   = '[data-toggle=dropdown]'
    , $par
    , firstItem
    , focusDelay = 200
    , menus = $(toggle).parent().find('ul').attr('role','menu')
    , lis = menus.find('li').attr('role','presentation')

  lis.find('a').attr({'role':'menuitem', 'tabIndex':'-1'})
  $(toggle).attr({ 'aria-haspopup':'true', 'aria-expanded': 'false'})

  $(toggle).parent().on('shown.bs.dropdown',function(e){
    $par = $(this);
    var $toggle = $par.find(toggle)
    $toggle.attr('aria-expanded','true');

    $par.children('ul').attr('aria-hidden', false);

/*
    setTimeout(function(){
          firstItem = $('.dropdown-menu [role=menuitem]:visible', $par)[0]
          try{ firstItem.focus()} catch(ex) {}
    }, focusDelay)
*/
  })

  $(toggle).parent().on('hidden.bs.dropdown',function(e){
    $par = $(this)
    var $toggle = $par.find(toggle);
    $toggle.attr('aria-expanded','false');
    $par.children('ul').attr('aria-hidden', true);
  })

  //Adding Space Key Behaviour, opens on spacebar
  $.fn.dropdown.Constructor.prototype.keydown = function (e) {
    var  $par
      , firstItem
    if (!/(32)/.test(e.keyCode)) return
      $par = $(this).parent()
      $(this).trigger ("click")
      e.preventDefault() && e.stopPropagation()
  }

  $(document)
    .on('focusout.dropdown.data-api', '.dropdown-menu', function(e){
      var $this = $(this)
                  , that = this
      if ($this.hasClass('multiselect-container')) { return; } //dont want the following action on the multiselect
      setTimeout(function() {
       if(!$.contains(that, document.activeElement)){
        $this.parent().removeClass('open')
        $this.parent().find('[data-toggle=dropdown]').attr('aria-expanded','false')
       }
      }, 150)
     })
    .on('keydown.bs.dropdown.data-api', toggle + ', [role=menu]' , $.fn.dropdown.Constructor.prototype.keydown);

  //end DROPDOWN

  // Tab Extension
  // Taken from https://github.com/paypal/bootstrap-accessibility-plugin/blob/master/plugins/js/bootstrap-accessibility.js
  // ===============================
  var uniqueId = function(prefix) {
        return (prefix || 'ui-id') + '-' + Math.floor((Math.random()*1000)+1)
  }

    var $tablist = $('.nav-tabs')
        , $lis = $tablist.children('li')
        , $tabs = $tablist.find('[data-toggle="tab"], [data-toggle="pill"]');

    if ($tabs.length > 0) {
        $tablist.attr('role', 'tablist')
        $lis.attr('role', 'presentation')
        $tabs.attr('role', 'tab')
    }

    $tabs.each(function( index ) {
      var tabHref = $(this).attr('href')
      var tabpanel = (tabHref === '#') ? null : $(tabHref)
        , tab = $(this)
        , tabid = tab.attr('id') || uniqueId('ui-tab')

        tab.attr('id', tabid)

      if(tab.parent().hasClass('active')){
        tab.attr( { 'tabIndex' : '0', 'aria-selected' : 'true', 'aria-controls': tab.attr('href').substring(1) } )
        if (tabpanel !== null) {
          tabpanel.attr({ 'role' : 'tabpanel', 'tabIndex' : '0', 'aria-hidden' : 'false', 'aria-labelledby':tabid })
        }
      }else{
        tab.attr( { 'tabIndex' : '-1', 'aria-selected' : 'false', 'aria-controls': tab.attr('href').substring(1) } )
        if (tabpanel !== null) {
          tabpanel.attr( { 'role' : 'tabpanel', 'tabIndex' : '-1', 'aria-hidden' : 'true', 'aria-labelledby':tabid } )
        }
      }
    })

    $.fn.tab.Constructor.prototype.keydown = function (e) {
      var $this = $(this)
      , $items
      , $ul = $this.closest('ul[role=tablist] ')
      , index
      , k = e.which || e.keyCode

      $this = $(this)
      if (!/(37|38|39|40)/.test(k)) return

      $items = $ul.find('[role=tab]:visible')
      index = $items.index($items.filter(':focus'))

      if (k == 38 || k == 37) index--                         // up & left
      if (k == 39 || k == 40) index++                        // down & right


      if(index < 0) index = $items.length -1
      if(index == $items.length) index = 0

      var nextTab = $items.eq(index)
      if(nextTab.attr('role') ==='tab'){

        nextTab.tab('show')      //Comment this line for dynamically loaded tabPabels, to save Ajax requests on arrow key navigation
        .focus()
      }
      // nextTab.focus()

      e.preventDefault()
      e.stopPropagation()
    }

    $(document).on('keydown.tab.data-api','[data-toggle="tab"], [data-toggle="pill"]' , $.fn.tab.Constructor.prototype.keydown)

   var tabactivate =    $.fn.tab.Constructor.prototype.activate;
   $.fn.tab.Constructor.prototype.activate = function (element, container, callback) {
      var $active = container.find('> .active')
      $active.find('[data-toggle=tab]').attr({ 'tabIndex' : '-1','aria-selected' : false })
      $active.filter('.tab-pane').attr({ 'aria-hidden' : true,'tabIndex' : '-1' })

      tabactivate.apply(this, arguments)

      element.addClass('active')
      element.find('[data-toggle=tab]').attr({ 'tabIndex' : '0','aria-selected' : true })
      element.filter('.tab-pane').attr({ 'aria-hidden' : false,'tabIndex' : '0' })
   }

   //END TABS


   springSpace.sui.icontip();


   //skip links
  // If there is a '#' in the URL (someone linking directly to a page with an anchor), highlight that section and set focus to it.
  // The tabindex attribute is removed AFTER the user navigates away from the element to help address a nasty VoiceOver bug.

  if (document.location.hash) {
    var myAnchor = document.location.hash;
    try {
      $(myAnchor).attr('tabindex', -1).on('blur focusout', function () {
        $(this).removeAttr('tabindex');
      }).focus();
    } catch(e) { }
  }

  /* This function looks for a change in the hash (activation of an in-page link) and sets focus to and
  highlights the target element. This is necessary because webkit does not set focus as it should. If
  the hash is empty (the user hit the back button after activating an in-page link) focus is set to body.
  */
  $(window).bind('hashchange', function() {
    var hash = "#"+window.location.hash.replace(/^#/,'');
    if (hash!="#") {
      $(hash).attr('tabindex', -1).on('blur focusout', function () {
        $(this).removeAttr('tabindex');
      }).focus();
    } else {
      $("body").attr('tabindex', -1).on('blur focusout', function () {
        $(this).removeAttr('tabindex');
      }).focus();
    }
  });



  // bootstrap-ckeditor-fix.js
  // hack to fix ckeditor/bootstrap compatiability bug when ckeditor appears in a bootstrap modal dialog
  //
  // Include this file AFTER both jQuery and bootstrap are loaded.
  //
  // Found here: http://stackoverflow.com/questions/31678662/ckeditor-issue-with-bootstrap-modal

  $.fn.modal.Constructor.prototype.enforceFocus = function() {
    modal_this = this
    $(document)
      .off('focusin.bs.modal')
      .on('focusin.bs.modal', function (e) {
      if (modal_this.$element[0] !== e.target && !modal_this.$element.has(e.target).length
      && !$( e.target ).closest( '.cke_dialog, .cke' ).length
      ) {
        modal_this.$element.focus()
      }
    })
  };

}); //end document ready
